<div [ngClass]="{'container-fluid' : showcaseType === showcasesTypes.NYT}"
  *ngIf="showcaseType; else showcase">
  <app-see-all-page
    *ngIf="entity"
    [showcaseType]="showcaseType"
    [entity]="entity"
    [isMultipleView]="isSeeAllMultiple"
    (scrollToContent)="onScrollToContent()">
  </app-see-all-page>
</div>
<ng-template #showcase>
  <app-showcase-page
    *ngIf="entity"
    [entity]="entity"
    [showcases]="showcases">
  </app-showcase-page>
</ng-template>

